import Image from './Image';

export default Image;



// WEBPACK FOOTER //
// ./src/image/index.js